/*
 * cart-variant-picker.js
 * Lets a customer change a line item's variant directly from the cart.
 * Shopify can't swap a variant in place, so we add the new variant and
 * remove the old line, both with `sections` so the theme's xCartHelper
 * re-renders the drawer instantly. theme.js is NOT modified.
 */
(function () {
  'use strict';

  function helper() {
    return (window.Alpine && Alpine.store) ? Alpine.store('xCartHelper') : null;
  }

  function postJSON(url, body) {
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function restore(selects, variants, currentId) {
    var cur = variants.find(function (v) { return String(v.id) === String(currentId); });
    if (!cur) return;
    selects.forEach(function (s, i) { s.value = cur.options[i]; });
  }

  /* A variant here carries only { id, available, options } — there is no
     `title` field, so the readable name has to be built from the options. */
  function optionLabel(variant) {
    return (variant && variant.options) ? variant.options.join(' / ') : '';
  }

  /* Over-the-limit is reported in the floating toast the rest of the site uses,
     not as a red block inside the cart line: the line keeps its height, nothing
     shifts, and every limit message on the site looks the same.
     `fit` carries the numbers when we checked up front; it is null when the
     safety net fired after the fact and we only know that it was refused. */
  function limitMessage(wrap, variant, qty, fit) {
    var api = window.AdmatiQtyLimit;
    var msg = wrap.getAttribute('data-cvp-msg-limit');
    if (!msg) {
      if (fit && fit.totalLabel && fit.limitLabel) {
        msg = optionLabel(variant) + ' × ' + qty + ' = ' + fit.totalLabel +
              ' — מעל המגבלה של ' + fit.limitLabel;
      } else {
        var lbl = api && api.getLimitLabel ? api.getLimitLabel(variant.id) : '';
        msg = 'לא ניתן לשנות ל־' + optionLabel(variant) + ' בכמות ' + qty +
              (lbl ? ' — מעל המגבלה של ' + lbl : ' — מעל מגבלת הכמות');
      }
    }
    if (api && api.notify) api.notify(msg);
    else {
      var errEl = wrap.querySelector('[data-cvp-error]');
      if (errEl) { errEl.textContent = msg; errEl.classList.remove('hidden'); }
    }
  }

  /* Grey out the weights that cannot fit at this line's current quantity, the
     same way the theme already greys out sold-out ones. Prevention beats an
     error message: the customer sees what is possible before choosing.
     Only applied to single-option lines (weight), where an <option> maps to
     exactly one variant; multi-option products fall back to the toast. */
  function annotate(wrap, fits) {
    var selects = wrap.querySelectorAll('select[data-cvp-option]');
    if (selects.length !== 1) return;
    var select = selects[0];

    var variants;
    try { variants = JSON.parse(wrap.querySelector('[data-cvp-variants]').textContent); }
    catch (e) { return; }

    var lineKey = wrap.getAttribute('data-cvp-key');
    var qty = parseInt(wrap.getAttribute('data-cvp-qty'), 10) || 1;
    var currentId = wrap.getAttribute('data-cvp-current');

    Array.prototype.forEach.call(select.options, function (opt) {
      // Remember how the option arrived from Liquid, so restoring never
      // resurrects a sold-out variant or loses its "אזל" suffix.
      if (!opt.hasAttribute('data-cvp-base')) {
        opt.setAttribute('data-cvp-base', opt.textContent);
        opt.setAttribute('data-cvp-base-disabled', opt.disabled ? '1' : '0');
      }
      var base = opt.getAttribute('data-cvp-base');
      var baseDisabled = opt.getAttribute('data-cvp-base-disabled') === '1';

      function reset() { opt.textContent = base; opt.disabled = baseDisabled; }

      var v = variants.find(function (x) { return x.options[0] === opt.value; });
      if (!v || String(v.id) === String(currentId)) { reset(); return; }

      var fit = fits(lineKey, v.id, qty);
      if (fit.ok) { reset(); return; }
      opt.textContent = base + ' — מעל ' + fit.limitLabel;
      opt.disabled = true;
    });
  }

  function refreshAll() {
    var wraps = document.querySelectorAll('[data-cvp]');
    if (!wraps.length) return;
    var api = window.AdmatiQtyLimit;
    if (!api || !api.getFitChecker) return;
    api.getFitChecker().then(function (fits) {
      Array.prototype.forEach.call(wraps, function (w) {
        try { annotate(w, fits); } catch (e) { /* never break the cart */ }
      });
    });
  }

  // The cart re-renders on every change, so re-annotate afterwards — the
  // quantity may have moved, which changes what still fits. The same pass
  // clears any stale message left over from a previous attempt.
  function onCartChanged() {
    setTimeout(function () {
      document.querySelectorAll('[data-cvp-error]').forEach(function (el) {
        el.classList.add('hidden');
        el.textContent = '';
      });
      refreshAll();
    }, 350);
  }

  document.addEventListener('eurus:cart:items-changed', onCartChanged);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  // Step a single option up (+1) or down (-1) by moving its <select> one
  // position and reusing cartVariantChange. Stops at the ends.
  // The button may live in a different column (the quantity slot), so it
  // points at its target <select> by id via data-cvp-target; falls back to
  // the nearest option row when used inline.
  window.cartVariantStep = function (btnEl, dir) {
    var select = null;
    var box = btnEl.closest('[data-cvp-stepbox]');
    if (box && box.getAttribute('data-cvp-target')) {
      select = document.getElementById(box.getAttribute('data-cvp-target'));
    }
    if (!select) {
      var row = btnEl.closest('[data-cvp-opt-row]');
      if (row) select = row.querySelector('select[data-cvp-option]');
    }
    if (!select) return;
    var next = select.selectedIndex + dir;
    if (next < 0 || next >= select.options.length) return;
    select.selectedIndex = next;
    window.cartVariantChange(select);
  };

  window.cartVariantChange = async function (selectEl) {
    var wrap = selectEl.closest('[data-cvp]');
    if (!wrap) return;
    var h = helper();
    if (!h) return;

    var lineKey = wrap.getAttribute('data-cvp-key');
    var qty = parseInt(wrap.getAttribute('data-cvp-qty'), 10) || 1;
    var currentId = wrap.getAttribute('data-cvp-current');

    var variants = [];
    var properties = {};
    try { variants = JSON.parse(wrap.querySelector('[data-cvp-variants]').textContent); }
    catch (e) { return; }
    try {
      var p = wrap.querySelector('[data-cvp-props]');
      if (p && p.textContent.trim()) properties = JSON.parse(p.textContent);
    } catch (e) { properties = {}; }

    var selects = Array.prototype.slice.call(wrap.querySelectorAll('select[data-cvp-option]'));
    var chosen = selects.map(function (s) { return s.value; });

    var match = variants.find(function (v) {
      return v.options.length === chosen.length &&
        v.options.every(function (o, i) { return o === chosen[i]; });
    });

    var errEl = wrap.querySelector('[data-cvp-error]');
    function showErr(msg) { if (errEl) { errEl.textContent = msg; errEl.classList.remove('hidden'); } }
    function clearErr() { if (errEl) { errEl.classList.add('hidden'); errEl.textContent = ''; } }
    clearErr();

    if (!match) {
      showErr(wrap.getAttribute('data-cvp-msg-unavailable') || 'הצירוף הזה לא קיים');
      restore(selects, variants, currentId);
      return;
    }
    if (String(match.id) === String(currentId)) return;
    if (!match.available) {
      showErr(wrap.getAttribute('data-cvp-msg-soldout') || 'אזל מהמלאי');
      restore(selects, variants, currentId);
      return;
    }

    // Pre-flight against the quantity limit BEFORE touching the cart: no
    // spinner, no request, no line that briefly disappears. The post-add check
    // further down stays as a safety net for races we cannot see from here.
    var qtyLimitEarly = window.AdmatiQtyLimit;
    if (qtyLimitEarly && qtyLimitEarly.getFitChecker) {
      try {
        var fits = await qtyLimitEarly.getFitChecker();
        var fit = fits(lineKey, match.id, qty);
        if (!fit.ok) {
          limitMessage(wrap, match, qty, fit);
          restore(selects, variants, currentId);
          return;
        }
      } catch (e) { /* a failed hint must never block a real change */ }
    }

    wrap.classList.add('cvp-loading');
    selects.forEach(function (s) { s.disabled = true; });
    var loadingEl = document.getElementById('loading-' + lineKey);
    if (loadingEl) loadingEl.classList.remove('hidden');

    // Swapping a weight is add-new-then-delete-old (Shopify cannot change a
    // line's variant in place). Tell the quantity limiter to ignore the line we
    // are replacing, otherwise it counts the old grams against the new ones and
    // refuses the add — after which the delete below would still run and the
    // customer would lose the product entirely.
    var qtyLimit = window.AdmatiQtyLimit;
    var blockedBefore = qtyLimit && qtyLimit.getBlockedCount ? qtyLimit.getBlockedCount() : 0;
    if (qtyLimit && qtyLimit.beginSwap) qtyLimit.beginSwap(lineKey);

    try {
      await h.waitForCartUpdate();
      window.updatingCart = true;
      var sectionIds = h.getSectionsToRender().map(function (s) { return s.id; });

      var addRes = await postJSON('cart/add.js', {
        items: [{ id: match.id, quantity: qty, properties: properties }],
        sections: sectionIds
      });
      if (addRes && addRes.status && Number(addRes.status) >= 400) {
        showErr(addRes.description || addRes.message || 'שגיאה בהוספה');
        restore(selects, variants, currentId);
        return;
      }
      // Never delete the old line unless the new one really went in.
      if (qtyLimit && qtyLimit.getBlockedCount && qtyLimit.getBlockedCount() > blockedBefore) {
        limitMessage(wrap, match, qty, null);
        restore(selects, variants, currentId);
        return;
      }

      var changeRes = await postJSON('cart/change.js', {
        id: lineKey,
        quantity: 0,
        sections: sectionIds
      });

      h.reRenderSections(changeRes.sections);
      if (typeof changeRes.item_count !== 'undefined') h.currentItemCount = changeRes.item_count;
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (e) {
      console.error('[cart-variant-picker]', e);
      showErr('שגיאה, נסה שוב');
      restore(selects, variants, currentId);
    } finally {
      if (qtyLimit && qtyLimit.endSwap) qtyLimit.endSwap();
      window.updatingCart = false;
      selects.forEach(function (s) { s.disabled = false; });
      wrap.classList.remove('cvp-loading');
      // The spinner is only ever cleared for us when the swap succeeds and the
      // cart section re-renders. On every abort path the line would otherwise
      // stay spinning for good, so put it back ourselves.
      if (loadingEl) loadingEl.classList.add('hidden');
    }
  };
})();
